import { isPlatformBrowser } from '@angular/common';
import { Component, DoCheck, Inject, OnChanges, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { Placement } from '@popperjs/core';
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements DoCheck{
  colorList: string[] = ['default', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'link', 'tertiary', 'ghost'];
  color = 'default' as string;
  sizeList: string[] = ['large', 'medium', 'small'];
  size = 'medium' as string;
  shapeList: string[] = ['square', 'circle'];
  shape = 'square' as string;
  buttonTypeList: string[] = ['button', 'submit'];
  buttonType = 'button';
  typeList: string[] = ['button', 'link'];
  type = 'button' as string;
  targetList: string[] = ['_blank', '_self'];
  target!: string;
  positionList: string[] = ['left', 'right', ''];
  position = '' as string;
  isOutline = false as boolean;
  disabled = false as boolean;
  hasQueryParams!: boolean;
  hasSpinner = false as boolean;
  queryParams = { test: 'dummy' };
  label = 'string';
  url!: string;
  icon!: string;
  tooltip!: string;
  ariaLabel!: string;
  isBrowser = true;
  ariaSelected = false;
  ariaCurrent = false;
  hasSpan = false;
  spanClass = 'u-button__text';
  placements: Placement[] = [
    'auto', 'top', 'bottom', 'right', 'left'
  ];
  selectedPlacement: Placement = 'bottom';
  constructor(
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }

  }
  ngDoCheck(): void {
    if(this.color==='ghost'){
      this.icon="icon-plus-circle";
    }
  }
}